import { useEffect, useMemo, useState } from 'react';

import { useSearchParams } from 'react-router-dom';

/**
 * Dönüşüm ihtiyacı olan keyler ve dönüşümü uygulayacak method
 */
const convert = {
  page: Number,
  pageSize: Number,
  itemsPerPage: Number,
};

export const useFilters = (defaultFilters) => {
  const [searchParams, setSearchParams] = useSearchParams();

  /**
   * Filtreler defaultFilters ve searchParams objesinden gelen verinin birleşmesi ile oluştuğu için
   * filtre değerleri her zaman string oluyor. Bazı filtrelerin spesifik veri tiplerinde olmaları gerektiği
   * için dönüştürme ihtiyacı olan keyler convert objesi kullanılarak istenen tipe dönüştürülür.
   */
  const paramObject = Object.fromEntries(searchParams.entries());
  const fixedParams = Object.fromEntries(Object.entries(paramObject).map(([k, v]) => [k, Object.keys(convert).includes(k) ? convert[k](v) : v]));

  const [filters, setFilters] = useState({ ...defaultFilters, ...fixedParams });

  const filtered = Object.keys(filters).find((k) => !Object.keys(defaultFilters).includes(k));

  useEffect(() => {
    setSearchParams({ ...searchParams, ...filters });
  }, [filters, searchParams, setSearchParams]);

  /**
   * API'ye gönderilecek parametreleri oluşturur.
   * _sort/_sortDir gibi internal key'leri API'nin beklediği formata (order[field]) dönüştürür.
   */
  const apiParams = useMemo(() => {
    const { _sort, _sortDir, ...params } = filters;
    if (_sort && _sortDir) {
      params[`order[${_sort}]`] = _sortDir;
    }
    return params;
  }, [filters]);

  return {
    filtered,
    filters,
    setFilters,
    apiParams,
    searchParams,
  };
};
